<p-dialog
    header="Select Variant Template"
    [visible]="visibleSignal()"
    (visibleChange)="onVisibleChange($event)"
    [style]="{ width: '56rem' }"
    [breakpoints]="{ '1280px': '95vw' }"
    appendTo="body"
    [modal]="true"
    [closable]="true"
    [draggable]="false"
>
    <div class="flex flex-col gap-3">
        @if (variantsService.templatesLoading()) {
            <p-message severity="info" text="Loading variant templates…" />
        } @else if (variantsService.templates().length === 0) {
            <p-message severity="warn" text="No variant templates available for this game on the game server." />
        } @else {
            <div class="text-sm text-muted-color">
                Pick a template to base the new variant on. You'll be able to override its values on the next step.
            </div>
            <div class="flex flex-col gap-2">
                @for (t of variantsService.templates(); track trackById($index, t)) {
                    <button
                        type="button"
                        class="flex flex-col gap-2 p-3 border border-surface-200 dark:border-surface-700 rounded text-left w-full hover:bg-surface-100 dark:hover:bg-surface-800 hover:border-primary-300 dark:hover:border-primary-700 transition-colors cursor-pointer bg-transparent"
                        (click)="pick(t)"
                    >
                        <div class="flex gap-3 items-start w-full">
                            @if (t.DisplayInfo.ImageUrl) {
                                <img [src]="resolveGameContentUrl(t.DisplayInfo.ImageUrl)" [alt]="t.DisplayInfo.Name" class="w-16 h-16 rounded object-cover flex-shrink-0" />
                            } @else {
                                <div class="w-16 h-16 rounded bg-surface-100 dark:bg-surface-800 flex items-center justify-center flex-shrink-0">
                                    <i class="pi pi-image text-muted-color"></i>
                                </div>
                            }
                            <div class="flex flex-col gap-2 flex-1 min-w-0">
                                <div class="flex items-center gap-2 flex-wrap">
                                    <div class="font-semibold">{{ t.DisplayInfo.Name || t.GameVariantTemplateId }}</div>
                                    @if (!t.IsActive) {
                                        <p-tag value="Template inactive" severity="warn" />
                                    }
                                </div>
                                @if (t.DisplayInfo.Description) {
                                    <div class="text-sm text-muted-color line-clamp-2">{{ t.DisplayInfo.Description }}</div>
                                }
                                <div class="grid grid-cols-2 md:grid-cols-4 gap-x-3 gap-y-1 text-xs mt-1">
                                    <div class="flex flex-col gap-0.5">
                                        <span class="text-muted-color uppercase tracking-wide">Type</span>
                                        <span class="font-medium">{{ modeConfigTypeLabel(t.ModeConfig) }}</span>
                                    </div>
                                    <div class="flex flex-col gap-0.5">
                                        <span class="text-muted-color uppercase tracking-wide">Players</span>
                                        <span class="font-medium inline-flex items-center gap-1">
                                            <i class="pi pi-users text-xs"></i>
                                            {{ variantPlayerCount(t.ModeConfig) ?? '—' }}
                                        </span>
                                    </div>
                                    <div class="flex flex-col gap-0.5">
                                        <span class="text-muted-color uppercase tracking-wide">Entry Fee</span>
                                        <span class="font-medium">
                                            @switch (variantEntryFee(t.ModeConfig).kind) {
                                                @case ('fixed') {
                                                    <app-funds-display [funds]="$any(variantEntryFee(t.ModeConfig)).funds" />
                                                }
                                                @case ('range') {
                                                    {{ $any(variantEntryFee(t.ModeConfig)).min }}–{{ $any(variantEntryFee(t.ModeConfig)).max }}
                                                    <span class="text-muted-color">({{ $any(variantEntryFee(t.ModeConfig)).currency }})</span>
                                                }
                                                @default { — }
                                            }
                                        </span>
                                    </div>
                                    <div class="flex flex-col gap-0.5">
                                        <span class="text-muted-color uppercase tracking-wide">Reward (1st)</span>
                                        <span class="font-medium inline-flex items-center gap-1">
                                            @if (variantTopReward(t.ModeConfig); as r) {
                                                <i class="pi pi-trophy text-xs"></i>
                                                <app-funds-display [funds]="r" />
                                            } @else {
                                                —
                                            }
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <i class="pi pi-chevron-right text-muted-color flex-shrink-0 mt-1"></i>
                        </div>
                        @if (t.Notes) {
                            <div class="text-xs text-muted-color border-t border-surface-200 dark:border-surface-700 pt-2 mt-1 w-full">
                                <span class="font-medium">Notes:</span> {{ t.Notes }}
                            </div>
                        }
                    </button>
                }
            </div>
        }
    </div>

    <ng-template #footer>
        <div class="flex justify-end">
            <p-button label="Cancel" severity="secondary" (onClick)="close()" />
        </div>
    </ng-template>
</p-dialog>
